<template>
    <span class="material-icons" v-if="attribute === 'name'"> done </span>
</template>

<script>
export default {
    name: "FieldIconPreview",
    props: {
        attribute: {
            type: String,
            required: false,
            default: "",
        },
    },
    data() {
        return {};
    },
};
</script>

<style lang="scss"></style>
